import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import type { Option } from './merchant-config.models';

/** Toggleable chips for picking several values out of a short list. */
@Component({
  selector: 'mm-chip-multi-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-wrap gap-1.5" role="group" [attr.aria-label]="label()">
      @for (option of options(); track option.value) {
        <button
          type="button"
          class="rounded-full border px-3 py-1 text-xs font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60"
          [class]="
            isOn(option.value)
              ? 'border-primary bg-primary/10 text-fg'
              : 'border-border bg-card text-muted hover:text-fg'
          "
          [attr.aria-pressed]="isOn(option.value)"
          [disabled]="disabled()"
          (click)="toggle(option.value)"
        >
          {{ option.label }}
        </button>
      }
    </div>
  `,
})
export class ChipMultiSelectComponent {
  readonly options = input.required<readonly { value: string; label: string }[]>();
  readonly label = input('');
  readonly disabled = input(false);
  readonly value = model<string[]>([]);

  isOn(value: string): boolean {
    return this.value().includes(value);
  }

  toggle(value: string): void {
    this.value.update((current) =>
      current.includes(value) ? current.filter((v) => v !== value) : [...current, value],
    );
  }
}

export type { Option };
